export default __webpack_public_path__ + "a9bd4a7a3a74d009abcec72ba3001375.png";